<template>
  <header class="header__wrapper" :class="wrapperDynamicClass">
    <div class="header__container">
      <a-header-logo />

      <a-visibility
        v-if="withNavigation"
        :hide="true"
        :on="[$breakpoint.mobile, $breakpoint.tablet]"
      >
        <a-header-navigation />
      </a-visibility>

      <slot name="right-section"></slot>

      <a-visibility
        v-if="withNavigation"
        :show="true"
        :on="[$breakpoint.mobile, $breakpoint.tablet]"
      >
        <a-header-mobile-menu class="header__mobile-menu" />
      </a-visibility>
    </div>
  </header>
</template>

<script>
import AHeaderNavigation from '@/components/_layout/AHeader/AHeaderNavigation'
import AHeaderLogo from '@/components/_layout/AHeader/AHeaderLogo'
import AHeaderMobileMenu from '@/components/_layout/AHeader/AHeaderMobileMenu'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'AHeader',
  components: {
    AHeaderMobileMenu,
    AHeaderLogo,
    AHeaderNavigation
  },
  props: {
    withNavigation: propValidator([PROP_TYPES.BOOLEAN], false, true)
  },
  computed: {
    ...mapGetters({
      isScrollbarHidden: 'isScrollbarHidden'
    }),
    wrapperDynamicClass() {
      return {
        'no-scroll': this.isScrollbarHidden
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$header-y-padding: 18px;

.header__wrapper {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: $z-index-header;
  background: $c--black;

  &.no-scroll {
    // To fix header "jumping" issue
    overflow-y: scroll;

    // But we have to reset this style on mobile, because otherwise
    // it will clip the mobile menu in iOS
    @include mobile {
      overflow-y: unset;
    }
  }

  .header__container {
    max-width: $desktop-container;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    $height: (
      $above-desktop-xl: $desktop-header-height,
      $tablet: $mobile-header-height
    );

    $padding: (
      $above-desktop-xl: $header-y-padding $padding-x-desktop-full-hd,
      $desktop-sm: $header-y-padding $padding-x-desktop-sm,
      $mobile: $header-y-padding $padding-x-mobile
    );

    @include setStyleByBreakpoint('padding', $padding);
    @include setStyleByBreakpoint('height', $height);
  }

  .header__mobile-menu {
    margin-left: 24px;
  }
}
</style>
